/**
 * Event name constants for app-wide event bus (Emitter).
 * Used by Emitter.on(), Emitter.emit(), etc.
 */

const EVENT_NAMES = {
  FORM: {
    ENTITY_STATE_UPDATE: 'form-entities-state-update',
    ENTITY_UPDATE: 'form-entities-update',
    ENTITY_UPDATE_SUCCESS: 'form-entities-update-success',
    ENTITY_ERROR: 'form-entities-error',
  },
  AUTH: {
    LOGIN_PROCEED: 'auth-login-proceed',
    LOGIN_SUCCESS: 'auth-login-success',
    LOGIN_SUCCESS_AFTER: 'auth-login-success-after',
    LOGIN_FAIL: 'auth-login-fail',
    LOGOUT_PROCEED: 'auth-logout-proceed',
    LOGOUT_SUCCESS: 'auth-logout-success',
    LOGOUT_SUCCESS_AFTER: 'auth-logout-success-after',
    LOGOUT_FAIL: 'auth-logout-fail',
    REGISTER_PROCEED: 'auth-register-proceed',
    REGISTER_SUCCESS: 'auth-register-success',
    REGISTER_FAIL: 'auth-register-fail',
    SESSION_WATCH: 'auth-session-watch',
    SESSION_PROCEED: 'auth-session-proceed',
    SESSION_SUCCESS: 'auth-session-success',
    SESSION_SUCCESS_AFTER: 'auth-session-success-after',
    SESSION_FAIL: 'auth-session-fail',
    SESSION_FAIL_AFTER: 'auth-session-fail-after',
    KEEPALIVE_PROCEED: 'sessions-keepalive-proceed',
    KEEPALIVE_SUCCESS: 'sessions-keepalive-success',
    KEEPALIVE_FAIL: 'sessions-keepalive-fail',
  },
  SESSIONS: {
    LIST_PROCEED: 'sessions-list-proceed',
    LIST_SUCCESS: 'sessions-list-success',
    LIST_FAIL: 'sessions-list-fail',
    CREATE_PROCEED: 'sessions-create-proceed',
    CREATE_SUCCESS: 'sessions-create-success',
    CREATE_FAIL: 'sessions-create-fail',
    READ_PROCEED: 'sessions-read-proceed',
    READ_SUCCESS: 'sessions-read-success',
    READ_FAIL: 'sessions-read-fail',
    UPDATE_PROCEED: 'sessions-update-proceed',
    UPDATE_SUCCESS: 'sessions-update-success',
    UPDATE_FAIL: 'sessions-update-fail',
    KEEPALIVE_PROCEED: 'sessions-keepalive-proceed',
    KEEPALIVE_SUCCESS: 'sessions-keepalive-success',
    KEEPALIVE_FAIL: 'sessions-keepalive-fail',
  },
  USER: {
    DETAIL_PROCEED: 'user-detail-proceed',
    DETAIL_SUCCESS: 'user-detail-success',
    DETAIL_FAIL: 'user-detail-fail',
  },
  ALERT: {
    INFO_DISPLAY: 'alert-info-display',
    INFO_SUCCESS: 'alert-info-success',
    INFO_FAIL: 'alert-info-fail',
    SUCCESS_DISPLAY: 'alert-success-display',
    SUCCESS_SUCCESS: 'alert-success-success',
    SUCCESS_FAIL: 'alert-success-fail',
    ERROR_DISPLAY: 'alert-error-display',
    ERROR_SUCCESS: 'alert-error-success',
    ERROR_FAIL: 'alert-error-fail',
    WARNING_DISPLAY: 'alert-warning-display',
    WARNING_SUCCESS: 'alert-warning-success',
    WARNING_FAIL: 'alert-warning-fail',
    QUESTION_DISPLAY: 'alert-question-display',
    QUESTION_SUCCESS: 'alert-question-success',
    QUESTION_FAIL: 'alert-question-fail',
    LOADING_DISPLAY: 'alert-loading-display',
    LOADING_STOP: 'alert-loading-stop',
    LOADING_SUCCESS: 'alert-loading-success',
    LOADING_FAIL: 'alert-loading-fail',
  },
  USERS: {
    LIST_PROCEED: 'users-list-proceed',
    LIST_SUCCESS: 'users-list-success',
    LIST_FAIL: 'users-list-fail',
    READ_PROCEED: 'users-read-proceed',
    READ_SUCCESS: 'users-read-success',
    READ_FAIL: 'users-read-fail',
  },
  TICKETS: {
    LIST_PROCEED: 'tickets-list-proceed',
    LIST_SUCCESS: 'tickets-list-success',
    LIST_FAIL: 'tickets-list-fail',
    CREATE_PROCEED: 'tickets-create-proceed',
    CREATE_SUCCESS: 'tickets-create-success',
    CREATE_FAIL: 'tickets-create-fail',
    READ_PROCEED: 'tickets-read-proceed',
    READ_SUCCESS: 'tickets-read-success',
    READ_FAIL: 'tickets-read-fail',
    UPDATE_PROCEED: 'tickets-update-proceed',
    UPDATE_SUCCESS: 'tickets-update-success',
    UPDATE_FAIL: 'sessions-update-fail',
  },
  TICKET_SLIP: {
    SET_TIPS_PROCEED: 'ticket-slip-set-tips-proceed',
    SET_TIPS_SUCCESS: 'ticket-slip-set-tips-success',
    CLEAR_TIPS_PROCEED: 'ticket-slip-clear-tips-proceed',
    CLEAR_TIPS_SUCCESS: 'ticket-slip-clear-tips-success',
    INSERT_TIP_PROCEED: 'ticket-slip-insert-tip-proceed',
    INSERT_TIP_SUCCESS: 'ticket-slip-insert-tip-success',
    REMOVE_TIP_PROCEED: 'ticket-slip-remove-tip-proceed',
    REMOVE_TIP_SUCCESS: 'ticket-slip-remove-tip-success',
    CHECK_INVALID_PROCEED: 'ticket-slip-check-invalid-proceed',
    CHECK_INVALID_SUCCESS: 'ticket-slip-check-invalid-success',
  },
  SPORTS: {
    LIST_PROCEED: 'sports-list-proceed',
    LIST_SUCCESS: 'sports-list-success',
    LIST_FAIL: 'sports-list-fail',
    READ_PROCEED: 'sports-read-proceed',
    READ_SUCCESS: 'sports-read-success',
    READ_FAIL: 'sports-read-fail',
    EVENT_LOAD: 'sports-event-load',
  },
  EVENT: {
    SET_CURRENT_PROCEED: 'events-set-current-proceed',
    SET_CURRENT_SUCCESS: 'events-set-current-success',
    SET_SELECTED_PROCEED: 'events-set-selected-proceed',
    SET_SELECTED_SUCCESS: 'events-set-selected-success',
    COUNTDOWN_PROCEED: 'events-countdown-proceed',
    NEXT_EVENT_COUNTDOWN_FINISHED: 'events-next-event-countdown-finished',
  },
  EVENTS: {
    LIST_PROCEED: 'events-list-proceed',
    LIST_SUCCESS: 'events-list-success',
    LIST_FAIL: 'events-list-fail',
    READ_PROCEED: 'events-read-proceed',
    READ_SUCCESS: 'events-read-success',
    READ_FAIL: 'events-read-fail',
    NEXT_PROCEED: 'events-next-proceed',
    NEXT_SUCCESS: 'events-next-success',
    NEXT_FAIL: 'events-next-fail',
    EACH_LOAD: 'events-each-load',
    ONGOING_PROCEED: 'events-ongoing-proceed',
    ONGOING_SUCCESS: 'events-ongoing-success',
    ONGOING_FAIL: 'events-ongoing-fail',
  },
  RESULTS: {
    EVENT_PROCEED: 'results-event-proceed',
    EVENT_SUCCESS: 'results-event-success',
    EVENT_FAIL: 'results-event-fail',
    LATEST_PROCEED: 'results-latest-proceed',
    LATEST_SUCCESS: 'results-latest-success',
    LATEST_FAIL: 'results-latest-fail',
    LAST_PROCEED: 'results-last-proceed',
    LAST_SUCCESS: 'results-last-success',
    LAST_FAIL: 'results-last-fail',
  },
  MEDIA: {
    EVOLUTION_PROCEED: 'media-evolution-proceed',
    PLAY_PROCEED: 'media-play-proceed',
    PLAY_FAIL: 'media-play-fail',
    BASEBALL_ENDED: 'media-baseball-ended',
    BASEBALL_CANPLAY: 'media-baseball-canplay',
    BASEBALL_ERROR: 'media-baseball-error',
    BASEBALL_PLAYING: 'media-baseball-playing',
    BASEBALL_PAUSE: 'media-baseball-pause',
    TIMEUPDATE_PROCEED: 'media-timeupdate-proceed',
  },
  MARKET_TYPES: {
    LIST_PROCEED: 'market-types-list-proceed',
    LIST_SUCCESS: 'market-types-list-success',
    LIST_FAIL: 'market-types-list-fail',
  },
  CREDITS: {
    CHECK_PROCEED: 'credits-check-proceed',
    CHECK_SUCCESS: 'credits-check-success',
    CHECK_FAIL: 'credits-check-fail',
    REBUY_PROCEED: 'credits-rebuy-proceed',
    REBUY_SUCCESS: 'credits-rebuy-success',
    REBUY_FAIL: 'credits-rebuy-fail',
    REQUEST_PROCEED: 'credits-request-proceed',
    REQUEST_SUCCESS: 'credits-request-success',
    REQUEST_ABORT: 'credits-request-abort',
    REQUEST_FAIL: 'credits-request-fail',
    WIN_PROCEED: 'credits-win-proceed',
    WIN_SUCCESS: 'credits-win-success',
    WIN_FAIL: 'credits-win-fail',
  },
  SERVER: {
    TIME_UPDATE_PROCEED: 'server-time-update-proceed',
    TIME_UPDATE_SUCCESS: 'server-time-update-success',
  },
  DIALOG: {
    SHOW: 'dialog-show',
    HIDE: 'dialog-hide',
  },
  USER_SETTINGS: {
    OPEN: 'user-settings-open',
  },
  LOGIN_MODAL: {
    OPEN: 'login-modal-open',
  },
  FADER: {
    CHANGE_PROCEED: 'fader-change-proceeed',
    SYNC_HEIGHT: 'fader-sync-height',
  },
  PLATFORM: {
    SESSIONS: {
      START_PROCEED: 'platform-sessions-start-proceed',
      START_SUCCESS: 'platform-sessions-start-success',
      START_SUCCESS_AFTER: 'platform-sessions-start-success-after',
      START_FAIL: 'platform-sessions-start-fail',
      TOKEN_PROCEED: 'platform-sessions-token-proceed',
      TOKEN_SUCCESS: 'platform-sessions-token-success',
      TOKEN_SUCCESS_AFTER: 'platform-sessions-token-success-after',
      TOKEN_FAIL: 'platform-sessions-token-fail',
      CSRF_PROCEED: 'platform-sessions-csrf-proceed',
      CSRF_SUCCESS: 'platform-sessions-csrf-success',
      CSRF_SUCCESS_AFTER: 'platform-sessions-csrf-success-after',
      CSRF_FAIL: 'platform-sessions-csrf-fail',
      CSRF_WATCH: 'platform-sessions-csrf-watch',
      CLOSE_PROCEED: 'platform-sessions-close-proceed',
      CLOSE_SUCCESS: 'platform-sessions-close-success',
      CLOSE_SUCCESS_AFTER: 'platform-sessions-close-success-after',
      CLOSE_FAIL: 'platform-sessions-close-fail',
    },
    SESSIONS_PREPAID: {
      READ_PROCEED: 'platform-sessions-prepaid-read-proceed',
      READ_SUCCESS: 'platform-sessions-prepaid-read-success',
      READ_SUCCESS_AFTER: 'platform-sessions-prepaid-read-success-after',
      READ_FAIL: 'platform-sessions-prepaid-read-fail',
      CREATE_PROCEED: 'platform-sessions-prepaid-create-proceed',
      CREATE_SUCCESS: 'platform-sessions-prepaid-create-success',
      CREATE_SUCCESS_AFTER: 'platform-sessions-prepaid-create-success-after',
      CREATE_FAIL: 'platform-sessions-prepaid-create-fail',
      DELETE_PROCEED: 'platform-sessions-prepaid-delete-proceed',
      DELETE_SUCCESS: 'platform-sessions-prepaid-delete-success',
      DELETE_SUCCESS_AFTER: 'platform-sessions-prepaid-delete-success-after',
      DELETE_FAIL: 'platform-sessions-prepaid-delete-fail',
    },
    WALLETS: {
      PAY_PROCEED: 'platform-sessions-pay-proceed',
      PAY_SUCCESS: 'platform-sessions-pay-success',
      PAY_SUCCESS_AFTER: 'platform-sessions-pay-success-after',
      PAY_FAIL: 'platform-sessions-pay-fail',
    },
  },
  /** PostMessage to parent when embedded (e.g. sportsbook iframe). Parent should listen for this and refresh iframe to guest. */
  EMBEDDING: {
    VIRTUAL_WEB_LOGOUT: 'VIRTUAL_WEB_LOGOUT',
  },
} as const;

export default EVENT_NAMES;
